import { Model } from './model';

import * as moment from 'moment';

export class DebarkationItem extends Model {
  id: number;
  weight: number;
  underweight: number;
  exemplars_number: number;
  presentation_type_name: string;
  presentation_type_conversion_factor: number;
  live_weight: number;
  activity_date: moment.Moment;
  rtp_date: moment.Moment;
  fao_zone: string;
  specie: string;
  conversion_factor_error: boolean;
  right_conversion_factor: number;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new DebarkationItem(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/debarkation-item.ts